export default __webpack_public_path__ + "static/media/img-egt-abp.82a57026.png";